export default "__VITE_ASSET__DjFfisb6__"